import moment from 'moment';
import React from 'react';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import Table from '../../Components/Table/Table';
import { convertCost } from '../../Utils/functions';

const BellHistory = () => {
    const modalRef = React.useRef(null);
    
    const columnsBell = React.useMemo(
        () => [
          {
            /* Header: '사유를 검색해보세요.', */
            Header: '변동사유',
            accessor: 'Reason', // accessor is the "key" in the data
            disableSortBy : true,
            width : 250,
            minWidth : 250
          },
          {
            Header: '사용일시',
            accessor: 'Date.$date',
            disableFilters : true,
            minWidth : 150,
            maxWidth : 150,
            width : 150,
            Cell : (props) => {
              return(
                  <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
              )
            }
          },
          {
            Header: '변경전 벨',
            accessor: 'BeforeBell',
            disableFilters : true,
            minWidth : 110,
            width : 110,
            Cell : (props) => {
              return(
                  <p style={{ fontWeight : 'bold', color : '#3f3f3f' }}>{convertCost(props.cell.value)}</p>
              )
            }
          },
          {
            Header: '변경된 벨',
            accessor: 'EditBell',
            disableFilters : true,
            minWidth : 110,
            width : 110,
            Cell : (props) => {
              return(
                  <p style={{ fontWeight : 'bold', color : '#3f3f3f' }}>{convertCost(props.cell.value)}</p>
              )
            }
          },
          {
            Header: '변경후 벨',
            accessor: 'AfterBell',
            disableFilters : true,
            minWidth : 110,
            width : 110,
            Cell : (props) => {
              return(
                  <p style={{ fontWeight : 'bold', color : '#3f3f3f' }}>{convertCost(props.cell.value)}</p>
              )
            }
          },
          {
            Header: '수정인',
            accessor: 'Editor',
            disableFilters : true,
            minWidth : 110,
            width : 110,
            Cell : (props) => {
              return(
                  <p>{props.cell.value === 'Auto' ? '시스템 자동' : props.cell.value === 'Manual' ? '점주 수동' : '본사'}</p>
              )
            }
          },
        ]
    )

    return (
        <div>
            <Table columns={columnsBell} url={'/api/history/bell'}/>
        </div>
    )
}

export default BellHistory;